/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import MockAdapter from 'axios-mock-adapter';
import { BaseFeatureMock } from './mockServer/featureMock';
import { RequestToCreateExcelDto } from './downloadings/downloadingsClient.typings';

const DELAYED_EXCEL: RegExp = /\/(operators|companies|stores|cashboxes|documents|devices)\/excel$/;
const EXCEL_URL_PREFIX: RegExp = /\/excel$/;
const LOGS_ZIP: RegExp = /\/logs\/\d+/;

class ExcelFeatureMock extends BaseFeatureMock {
    public readonly delayedExcel = this.route<RequestToCreateExcelDto, Record<string, unknown>>({
        method: 'post',
        url: DELAYED_EXCEL,
        defaultResponse: () => {
            const data: RequestToCreateExcelDto = {
                requestedDateAtUtc: '2023-02-02T10:27:11.996063',
                id: 678987,
                name: 'some s3 name',
                status: 'CREATED',
                type: 'OBJECTS',
            };
            return [200, data];
        },
        delayMs: 100,
    });

    public readonly getExcel = this.route<string[]>({
        method: 'get',
        url: EXCEL_URL_PREFIX,
        defaultResponse: () => {
            return [
                200,
                ['The application is running on mock data, this excel file is a simple plug (for GET endpoint).'],
            ];
        },
        delayMs: 100,
    });

    public readonly postExcel = this.route<string[]>({
        method: 'post',
        url: EXCEL_URL_PREFIX,
        defaultResponse: () => {
            return [
                200,
                ['The application is running on mock data, this excel file is a simple plug (for POST endpoint).'],
            ];
        },
        delayMs: 100,
    });

    public readonly logsZip = this.route<string[]>({
        method: 'get',
        url: LOGS_ZIP,
        defaultResponse: () => {
            return [200, ['The application is running on mock data, this zip file is a simple plug']];
        },
        delayMs: 100,
    });
}

export const excelMock = new ExcelFeatureMock();

/** Backward-compat shim - dev mock mode (mockAdapter.ts) keeps calling this untouched. */
export function addExcelMockApi(mockAdapter: MockAdapter): void {
    excelMock.register(mockAdapter, { delay: true });
}
